import { jwtDecode } from 'jwt-decode';

/**
 * Check if token is expired or about to expire
 * @param {string} token - JWT token
 * @param {number} bufferMinutes - Minutes before expiry to consider token as expired
 * @returns {boolean} - true if token is expired or about to expire
 */
export const isTokenExpired = (token, bufferMinutes = 5) => {
  if (!token) return true;
  
  try {
    const decoded = jwtDecode(token);
    const expiryTime = decoded.exp * 1000; // Convert to milliseconds
    const currentTime = Date.now();
    const bufferTime = bufferMinutes * 60 * 1000; // Convert buffer to milliseconds
    
    // Return true if token will expire within buffer time
    return (expiryTime - currentTime) < bufferTime;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;
  }
};

/**
 * Get time remaining until token expires
 * @param {string} token - JWT token
 * @returns {number} - Minutes remaining, or 0 if expired
 */
export const getTokenTimeRemaining = (token) => {
  if (!token) return 0;
  
  try {
    const decoded = jwtDecode(token);
    const expiryTime = decoded.exp * 1000;
    const currentTime = Date.now();
    const timeRemaining = expiryTime - currentTime;
    
    if (timeRemaining <= 0) return 0;
    
    return Math.floor(timeRemaining / (60 * 1000)); // Convert to minutes
  } catch (error) {
    console.error('Error getting token time:', error);
    return 0;
  }
};
